import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import styles from './styles.module.scss';

import { ChevronIcon } from '../Icons';

const Select = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select...',
}) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);

  const selectedOption = options.find((option) => option.id === value);

  const handleSelect = (option) => {
    if (onChange) onChange(option.id);
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className={styles.container}>
        <button
          type='button'
          ref={triggerRef}
          className={classNames(styles.trigger, { [styles.triggerOpen]: open })}
          onClick={() => setOpen((previous) => !previous)}
          aria-haspopup='listbox'
          aria-expanded={open}
        >
          <span className={styles.value}>
            {selectedOption ? selectedOption.title : placeholder}
          </span>
          <ChevronIcon className={classNames(styles.chevron, { [styles.chevronOpen]: open })} />
        </button>

        {open && (
          <div className={styles.menu} role='listbox' aria-label='Select option'>
            {options.map((option) => (
              <button
                key={option.id}
                type='button'
                role='option'
                aria-selected={option.id === value}
                className={classNames(styles.option, { [styles.optionSelected]: option.id === value })}
                onClick={() => handleSelect(option)}
              >
                {option.title}
              </button>
            ))}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default Select;
